import ColorFormat from "./ColorFormat";

enum ColorFormatPreference {
    Auto = "auto",
    RGBA = "rgba",
    HexRGBA = "hexRGBA",
    HexARGB = "hexARGB",
    HSL = "hsl"
}

const NAMES: Record<ColorFormatPreference, string> = {
    [ColorFormatPreference.Auto]: "Automatic",
    [ColorFormatPreference.RGBA]: "RGBA",
    [ColorFormatPreference.HexRGBA]: "Hex (RGB, A)",
    [ColorFormatPreference.HexARGB]: "Hex (ARGB)",
    [ColorFormatPreference.HSL]: "HSL"
};

function getColorFormatForPreference(colorFormatPreference: ColorFormatPreference): ColorFormat | undefined {
    switch (colorFormatPreference) {
        case ColorFormatPreference.RGBA:
            return ColorFormat.RGBA;
        case ColorFormatPreference.HexRGBA:
            return ColorFormat.HexRGBA;
        case ColorFormatPreference.HexARGB:
            return ColorFormat.HexARGB;
        case ColorFormatPreference.HSL:
            return ColorFormat.HSL;
        case ColorFormatPreference.Auto:
        default:
            return undefined;
    }
}

function getColorFormatPreferenceName(colorFormatPreference: ColorFormatPreference): string {
    return NAMES[colorFormatPreference];
}

export default ColorFormatPreference;

export {
    getColorFormatForPreference,
    getColorFormatPreferenceName
};
